import type {
  WorkflowClientCommandReference,
  WorkflowCommandContext,
} from './workflow-command-registry';

/** A trusted no-input action. Its destination is owned by the retained workflow, never by the browser. */
export const workflowCompleteCommandAdapter = {
  matches(reference: WorkflowClientCommandReference): boolean {
    const key = reference.key;
    return (
      key.provider === 'workflow' &&
      key.kind === 'command' &&
      key.code === 'workflow.step.complete' &&
      key.version === 1 &&
      !!reference.inputSchemaHash &&
      !!reference.outputSchemaHash &&
      !!reference.contractHash
    );
  },
  request(
    context: WorkflowCommandContext,
  ): {
    suffix: string;
    body: { occurrenceId: number; expectedETag: string };
  } | null {
    return Number.isSafeInteger(context.workflowInstanceId) &&
      context.workflowInstanceId > 0 &&
      Number.isSafeInteger(context.occurrenceId) &&
      context.occurrenceId! > 0 &&
      context.stepETag
      ? {
          suffix: '/requirements/complete',
          body: {
            occurrenceId: context.occurrenceId!,
            expectedETag: context.stepETag,
          },
        }
      : null;
  },
};
